export const translations = {
  en: {
    // Navbar
    nav: {
      shows: "Shows",
      about: "About",
      gallery: "Gallery",
      myTickets: "My Tickets",
      contact: "Contact",
      buyTickets: "Buy Tickets",
    },
    // Hero
    hero: {
      title: "JAZZ INSIGHTS",
      subtitle: "Experience the soul of jazz in the heart of Plovdiv. Live performances, intimate atmosphere, unforgettable nights.",
      viewShows: "View Upcoming Shows",
      ourStory: "Our Story",
      established: "Est. 2020",
    },
    // Shows
    shows: {
      title: "Upcoming Shows",
      subtitle: "Experience world-class jazz performances in our intimate venue",
      featured: "Featured Event",
      tonight: "Tonight",
      seats: "seats left",
      soldOut: "Sold Out",
      viewDetails: "View Details",
      limitedAvailability: "Almost Sold Out",
      getTickets: "Get Tickets",
      learnMore: "Learn More",
      noShows: "No upcoming shows at the moment. Check back soon!",
      perPerson: "/person",
      eventImage: "Event Image",
      ticketsLeft: "tickets left!",
    },
    // About
    about: {
      title: "Our Story",
      heading1: "Sanctuary",
      heading2: "for",
      heading3: "Jazz Lovers Since 2020",
      p1: "Since opening our doors in 2020, Jazz Insights has been a sanctuary for jazz lovers and musicians alike. Our intimate venue in the heart of Plovdiv offers an unparalleled acoustic experience.",
      p2: "We believe in the power of live music to connect people. Every performance at Jazz Insights is a unique experience, bringing together world-class musicians and passionate audiences.",
      p3: "Our commitment to excellence extends beyond the stage. From our carefully curated cocktail menu to our warm, welcoming atmosphere, every detail is designed to enhance your jazz experience.",
      stats: {
        experience: "Years Experience",
        guests: "Happy Guests",
        musicians: "Featured Musicians",
        performances: "Live Performances",
      },
    },
    // Gallery
    gallery: {
      title: "Gallery",
      clubTitle: "Club",
      subtitle: "Moments captured at Jazz Insights",
      prev: "Previous",
      next: "Next",
      close: "Close",
      view: "View",
    },
    // My Tickets
    myTickets: {
      sectionLabel: "Your Purchases",
      title: "My Tickets",
      subtitle: "Enter your email to receive a verification code for secure access to your tickets.",
      emailPlaceholder: "Enter your email address",
      searchButton: "Send Code",
      searching: "Sending...",
      confirmedTickets: "Confirmed Tickets",
      otherOrders: "Other Orders",
      quantity: "Quantity",
      tickets: "tickets",
      ticket: "ticket",
      total: "Total",
      name: "Name",
      orderNumber: "Order #",
      downloadPdf: "Download PDF",
      addToCalendar: "Add to Calendar",
      googleCalendar: "Google Calendar",
      appleOutlook: "Apple / Outlook (.ics)",
      qrCodeNote: "Present this QR code at the venue entrance",
      generating: "Generating...",
      noTickets: "No Tickets Found",
      noTicketsDesc: "We couldn't find any orders associated with this email address.",
      confirmed: "Confirmed",
      pending: "Pending",
      cancelled: "Cancelled",
      invalidEmail: "Please enter a valid email address",
      loadError: "Failed to load tickets. Please try again.",
      verificationSent: "Verification code sent to your email",
      enterCode: "Enter the 6-digit code sent to your email",
      codePlaceholder: "Enter 6-digit code",
      verifyButton: "Verify",
      verifying: "Verifying...",
      invalidCode: "Invalid or expired code. Please try again.",
      codeExpired: "Code expired. Please request a new one.",
      resendCode: "Resend Code",
      backToEmail: "Use different email",
    },
    // Contact
    contact: {
      title: "Visit Us",
      subtitle: "Experience live jazz in the heart of Plovdiv",
      findTitle: "Find",
      location: "Location",
      hours: "Hours",
      hoursValue: "Thu - Sat: 7PM - 11:30PM",
      phone: "Phone",
      email: "Email",
    },
    // Footer
    footer: {
      rights: "All rights reserved.",
      privacyPolicy: "Privacy Policy",
      subscribeTitle: "Subscribe for Updates",
      subscribeDesc: "Get notified about new events directly in your inbox.",
    },
    // Subscribe Form
    subscribe: {
      placeholder: "Your email",
      button: "Subscribe",
      success: "You're subscribed!",
      alreadySubscribed: "Already subscribed",
      alreadySubscribedDesc: "This email is already registered.",
      successTitle: "Subscribed!",
      successDesc: "You'll receive notifications about new events.",
      invalidEmail: "Invalid email",
      invalidEmailDesc: "Please enter a valid email address.",
      errorTitle: "Error",
      errorDesc: "Failed to subscribe. Please try again.",
    },
    // Ticket Modal
    ticketModal: {
      getTickets: "Get Tickets",
      selectTickets: "Select number of tickets",
      chooseTickets: "Choose how many tickets you need",
      ticketsFor: "tickets for",
      yourDetails: "Your Details",
      sendTicketsHere: "We'll send your tickets here",
      fullName: "Full Name",
      fullNamePlaceholder: "Enter your full name",
      email: "Email Address",
      emailPlaceholder: "Enter your email",
      orderSummary: "Order Summary",
      completePurchase: "Complete Purchase",
      reviewOrder: "Review and confirm your order",
      show: "Show",
      date: "Date",
      ticketsLabel: "Tickets",
      time: "Time",
      venue: "Venue",
      proceedToPayment: "Proceed to Payment",
      processing: "Processing...",
      securePaymentNotice: "You will be redirected to Stripe for secure payment processing",
      acceptTerms: "I accept the",
      termsAndConditions: "Terms and Conditions",
      acceptTermsError: "Please accept the Terms and Conditions to continue",
      redirecting: "Redirecting to secure payment...",
      stepSelect: "Select",
      stepDetails: "Details",
      stepPayment: "Payment",
      back: "Back",
      continue: "Continue",
      backToDetails: "Back to details",
      onlyTicketsLeft: "Only {count} tickets left!",
      verifyHuman: "Please verify you're human",
      verificationFailed: "Verification failed. Please try again.",
      stepSeats: "Seats",
      selectSeats: "Choose Your Seats",
      chooseSeatInstruction: "Tap on available seats to select them",
      noSeatsSelected: "Please select at least one seat",
      selectedSeatsCount: "{count} seat(s) selected",
      quantityLabel: "Quantity",
      seatsLabel: "Seats",
      seatSingular: "seat",
      seatPlural: "seats",
      ticketSingular: "ticket",
      ticketPlural: "tickets",
    },
    // Show Detail Drawer
    showDetail: {
      featured: "Featured Event",
      dateTime: "Date & Time",
      venue: "Venue",
      venueName: "Jazz Insights, Plovdiv",
      availability: "Availability",
      seatsAvailable: "seats available",
      soldOut: "Sold Out",
      aboutEvent: "About This Event",
      defaultDesc1: "Join us for an unforgettable evening of jazz at Jazz Insights. This performance promises to deliver an exceptional musical experience in our intimate venue setting.",
      defaultDesc2: "Our world-class sound system and cozy atmosphere create the perfect environment for experiencing live jazz. Whether you're a long-time jazz enthusiast or new to the genre, this show offers something special for everyone.",
      getTickets: "Get Tickets",
      pricePerPerson: "Price per person",
      eventDetails: "Event details for",
      share: "Share Event",
      linkCopied: "Link copied!",
    },
    // Install Prompt
    install: {
      title: "Install Jazz Insights",
      description: "Add to your home screen for quick access",
      button: "Install App",
      iosInstructions: "Tap Share, then 'Add to Home Screen'",
    },
  },
  bg: {
    // Navbar
    nav: {
      shows: "Концерти",
      about: "За нас",
      gallery: "Галерия",
      myTickets: "Моите билети",
      contact: "Контакти",
      buyTickets: "Купи билети",
    },
    // Hero
    hero: {
      title: "JAZZ INSIGHTS",
      subtitle: "Усетете душата на джаза в сърцето на Пловдив. Живи изпълнения, интимна атмосфера, незабравими вечери.",
      viewShows: "Предстоящи концерти",
      ourStory: "Нашата история",
      established: "От 2020",
    },
    // Shows
    shows: {
      title: "Предстоящи концерти",
      subtitle: "Насладете се на джаз изпълнения от световна класа в нашия интимен клуб",
      featured: "Специално събитие",
      tonight: "Тази вечер",
      seats: "свободни места",
      soldOut: "SOLD OUT",
      viewDetails: "Вижте детайли",
      limitedAvailability: "Почти разпродадено",
      getTickets: "Купи билети",
      learnMore: "Научи повече",
      noShows: "Няма предстоящи концерти в момента. Проверете отново скоро!",
      perPerson: "/човек",
      eventImage: "Изображение",
      ticketsLeft: "билета останаха!",
    },
    // About
    about: {
      title: "Нашата история",
      heading1: "Убежище",
      heading2: "за",
      heading3: "Любителите на джаза от 2020",
      p1: "Откакто отворихме врати през 2020 г., Jazz Insights е убежище за любителите на джаза и музикантите. Нашият интимен клуб в сърцето на Пловдив предлага несравнимо акустично изживяване.",
      p2: "Вярваме в силата на живата музика да свързва хората. Всяко изпълнение в Jazz Insights е уникално преживяване, събиращо музиканти от световна класа и страстна публика.",
      p3: "Нашият ангажимент към съвършенство се простира отвъд сцената. От внимателно подбраното ни коктейлно меню до топлата, гостоприемна атмосфера, всеки детайл е създаден да подобри вашето джаз изживяване.",
      stats: {
        experience: "Години опит",
        guests: "Доволни гости",
        musicians: "Представени музиканти",
        performances: "Живи изпълнения",
      },
    },
    // Gallery
    gallery: {
      title: "Галерия",
      clubTitle: "Клуб",
      subtitle: "Уловени моменти в Jazz Insights",
      prev: "Предишна",
      next: "Следваща",
      close: "Затвори",
      view: "Виж",
    },
    // My Tickets
    myTickets: {
      sectionLabel: "Вашите покупки",
      title: "Моите билети",
      subtitle: "Въведете имейла си, за да получите код за сигурен достъп до вашите билети.",
      emailPlaceholder: "Въведете имейл адрес",
      searchButton: "Изпрати код",
      searching: "Изпращане...",
      confirmedTickets: "Потвърдени билети",
      otherOrders: "Други поръчки",
      quantity: "Количество",
      tickets: "билета",
      ticket: "билет",
      total: "Общо",
      name: "Име",
      orderNumber: "Поръчка #",
      downloadPdf: "Изтегли PDF",
      addToCalendar: "Добави в календар",
      googleCalendar: "Google Календар",
      appleOutlook: "Apple / Outlook (.ics)",
      qrCodeNote: "Покажете този QR код на входа",
      generating: "Генериране...",
      noTickets: "Няма намерени билети",
      noTicketsDesc: "Не открихме поръчки, свързани с този имейл адрес.",
      confirmed: "Потвърдена",
      pending: "Изчакваща",
      cancelled: "Отменена",
      invalidEmail: "Моля, въведете валиден имейл адрес",
      loadError: "Неуспешно зареждане на билети. Моля, опитайте отново.",
      verificationSent: "Кодът за потвърждение е изпратен на вашия имейл",
      enterCode: "Въведете 6-цифрения код, изпратен на имейла ви",
      codePlaceholder: "Въведете 6-цифрен код",
      verifyButton: "Потвърди",
      verifying: "Потвърждаване...",
      invalidCode: "Невалиден или изтекъл код. Моля, опитайте отново.",
      codeExpired: "Кодът е изтекъл. Моля, поискайте нов.",
      resendCode: "Изпрати отново",
      backToEmail: "Използвай друг имейл",
    },
    // Contact
    contact: {
      title: "Посетете ни",
      subtitle: "Усетете живия джаз в сърцето на Пловдив",
      findTitle: "Открийте",
      location: "Адрес",
      hours: "Работно време",
      hoursValue: "Чет - Съб: 19:00 - 23:30",
      phone: "Телефон",
      email: "Имейл",
    },
    // Footer
    footer: {
      rights: "Всички права запазени.",
      privacyPolicy: "Политика за поверителност",
      subscribeTitle: "Абонирайте се за известия",
      subscribeDesc: "Получавайте известия за нови събития директно в пощата си.",
    },
    // Subscribe Form
    subscribe: {
      placeholder: "Вашият имейл",
      button: "Абонирай се",
      success: "Абонирани сте!",
      alreadySubscribed: "Вече сте абонирани",
      alreadySubscribedDesc: "Този имейл вече е регистриран.",
      successTitle: "Успешно абониране!",
      successDesc: "Ще получавате известия за нови събития.",
      invalidEmail: "Невалиден имейл",
      invalidEmailDesc: "Моля, въведете валиден имейл адрес.",
      errorTitle: "Грешка",
      errorDesc: "Неуспешно абониране. Моля, опитайте отново.",
    },
    // Ticket Modal
    ticketModal: {
      getTickets: "Купи билети",
      selectTickets: "Изберете брой билети",
      chooseTickets: "Изберете колко билета ви трябват",
      ticketsFor: "билета за",
      yourDetails: "Вашите данни",
      sendTicketsHere: "Ще изпратим билетите тук",
      fullName: "Пълно име",
      fullNamePlaceholder: "Въведете пълното си име",
      email: "Имейл адрес",
      emailPlaceholder: "Въведете имейл",
      orderSummary: "Обобщение на поръчката",
      completePurchase: "Завършете покупката",
      reviewOrder: "Прегледайте и потвърдете поръчката",
      show: "Концерт",
      date: "Дата",
      ticketsLabel: "Билети",
      time: "Час",
      venue: "Място",
      proceedToPayment: "Продължи към плащане",
      processing: "Обработка...",
      securePaymentNotice: "Ще бъдете пренасочени към Stripe за сигурна обработка на плащането",
      acceptTerms: "Приемам",
      termsAndConditions: "Общите условия",
      acceptTermsError: "Моля, приемете Общите условия, за да продължите",
      redirecting: "Пренасочване към плащане...",
      stepSelect: "Избор",
      stepDetails: "Данни",
      stepPayment: "Плащане",
      back: "Назад",
      continue: "Продължи",
      backToDetails: "Назад към данните",
      onlyTicketsLeft: "Само {count} билета останаха!",
      verifyHuman: "Моля, потвърдете, че сте човек",
      verificationFailed: "Проверката се провали. Моля, опитайте отново.",
      stepSeats: "Места",
      selectSeats: "Изберете места В Джаза",
      chooseSeatInstruction: "Натиснете върху свободните места за избор",
      noSeatsSelected: "Моля, изберете поне едно място",
      selectedSeatsCount: "{count} място/а избрано/и",
      quantityLabel: "Брой билети",
      seatsLabel: "Места",
      seatSingular: "място",
      seatPlural: "места",
      ticketSingular: "билет",
      ticketPlural: "билета",
    },
    // Show Detail Drawer
    showDetail: {
      featured: "Специално събитие",
      dateTime: "Дата и час",
      venue: "Място",
      venueName: "Jazz Insights, Пловдив",
      availability: "Наличност",
      seatsAvailable: "свободни места",
      soldOut: "SOLD OUT",
      aboutEvent: "За събитието",
      defaultDesc1: "Присъединете се към нас за незабравима вечер на джаз в Jazz Insights. Това изпълнение обещава да достави изключително музикално изживяване в нашата интимна обстановка.",
      defaultDesc2: "Нашата звукова система от световна класа и уютна атмосфера създават перфектната среда за преживяване на жив джаз. Независимо дали сте дългогодишен ентусиаст на джаза или сте нови в жанра, този концерт предлага нещо специално за всеки.",
      getTickets: "Купи билети",
      pricePerPerson: "Цена на човек",
      eventDetails: "Детайли за събитието",
      share: "Сподели събитие",
      linkCopied: "Линкът е копиран!",
    },
    // Install Prompt
    install: {
      title: "Инсталирай Jazz Insights",
      description: "Добави на началния екран за бърз достъп",
      button: "Инсталирай",
      iosInstructions: "Натисни Сподели, след това 'Добави на начален екран'",
    },
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKeys = typeof translations.en;
